import API from '../index';
import { TaxInfo } from '../../types/common';
import { getTaxInfoPayload } from '.';

const saveCustomerTaxInfo = async (taxInfo: TaxInfo): Promise<TaxInfo> => {
  const payload = getTaxInfoPayload(taxInfo);
  const data: TaxInfo = await API.post(`/taxes/TW`, payload);
  return data;
};

export default saveCustomerTaxInfo;
